exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Overview-module__wrapper___1sPSG{display:grid;grid-template-columns:repeat(2,275px);gap:1.5em}@media screen and (min-width:1000px){.Overview-module__wrapper___1sPSG{grid-template-columns:repeat(3,275px)}}.Overview-module__tile-text___JbcCZ{background-color:#fff;padding:.25em;border-radius:4px;display:grid;gap:.5em}.Overview-module__tile-wrapper___1aEFB{display:grid;gap:4px;justify-content:center;grid-template-columns:repeat(11,1fr);grid-template-rows:20px}", ""]);

// exports
exports.locals = {
	"wrapper": "Overview-module__wrapper___1sPSG",
	"tile-text": "Overview-module__tile-text___JbcCZ",
	"tile-wrapper": "Overview-module__tile-wrapper___1aEFB"
};